<template>
    <div>
        <div class="o-recruit-memberTab">
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--sales">
                <button
                    :class="[current_department === 'sales' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('sales')"
                >
                    セールス
                </button>
            </div>
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--cs">
                <button
                    :class="[current_department === 'customersuccess' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('customersuccess')"
                >
                    カスタマーサクセス
                </button>
            </div>
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--mc">
                <button
                    :class="[current_department === 'marketing' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('marketing')"
                >
                    企画 / マーケティング
                </button>
            </div>
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--co">
                <button
                    :class="[current_department === 'corporate' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('corporate')"
                >
                    コーポレート
                </button>
            </div>
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--pr">
                <button
                    :class="[current_department === 'product' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('product')"
                >
                    プロダクト
                </button>
            </div>
            <div class="o-recruit-memberTab__item o-recruit-memberTab__item--op">
                <button
                    :class="[current_department === 'operation' ? 'is-active' : '']"
                    class="o-recruit-memberTab__btn"
                    @Click="departmentChange('operation')"
                >
                    オペレーション / 翻訳者
                </button>
            </div>
        </div>
        <h3 class="o-recruit-memberListArea__ttl">{{ current_department_text }}チーム</h3>
        <Memberlist
            :memberlist="current_list"
            :department="current_department"
            :departmentText="current_department_text"
        ></Memberlist>
        <div class="o-recruit-memberTab__detailLink">
            <a :href="current_department_url" class="c-btn">{{ current_department_text }}チームについて詳しく見る</a>
        </div>
    </div>
</template>

<script>
    import Memberitem from './memberitem.vue'
    import Memberlist from './memberList.vue'
    import modal from './modal.vue'

    export default {
        components: {
            Memberlist,
            Memberitem,
            modal,
        },
        props:{
        },
        mounted() {
            this.setDepartment(this.current_department)
        },
        data() {
            return {
                department_list: department_list,
                current_department: 'sales',
                current_list: {},
                department_text_list: {
                    sales : 'セールス',
                    customersuccess : 'カスタマーサクセス',
                    marketing : '企画 / マーケティング',
                    corporate: 'コーポレート',
                    product : 'プロダクト',
                    operation: 'オペレーション / 翻訳者',
                },
                department_url_list: {
                    sales : './sales_customersuccess/',
                    customersuccess : './sales_customersuccess/',
                    marketing : './marketing/',
                    corporate: './corporate/',
                    product : './product/',
                    operation: './operation/',
                }
            };
        },
        computed: {
            current_department_text: function () {
                return this.department_text_list[this.current_department]
            },
            current_department_url: function () {
                return this.department_url_list[this.current_department]
            }
        },
        methods: {
            departmentChange(department) {
                    this.setDepartment(department)
            },
            setDepartment(department) {
                this.current_department = department
                this.current_list = this.department_list[this.current_department].list
            },
        }
    }
</script>
<style scoped>

</style>